import { render, staticRenderFns } from "./MaterialsChapters.vue?vue&type=template&id=3049436e&scoped=true"
import script from "./MaterialsChapters.vue?vue&type=script&lang=ts"
export * from "./MaterialsChapters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3049436e",
  null
  
)

export default component.exports